import { render, staticRenderFns } from "./FlushDmarcPolicy.vue?vue&type=template&id=295c02b6&"
import script from "./FlushDmarcPolicy.vue?vue&type=script&lang=js&"
export * from "./FlushDmarcPolicy.vue?vue&type=script&lang=js&"
import style0 from "./FlushDmarcPolicy.vue?vue&type=style&index=0&id=295c02b6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports